import { Flame } from "lucide-react";
import { ADDRESS, ORDER_URL, PHONE, PHONE_LINK, RESERVE_URL } from "@/data/menu";

export const Footer = () => (
  <footer className="bg-forest text-[#FFF9F1]" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <img
            src="/logo.jpg"
            alt="Northgate Flavour Express logo"
            data-testid="footer-logo"
            className="mb-6 h-32 w-32 rounded-2xl border border-[#FFF9F1]/20 bg-white object-contain p-1.5 shadow-lg"
          />
          <p className="flex items-center gap-2 font-mono-alt text-[11px] uppercase tracking-[0.3em] text-[#E8B84B]">
            <Flame size={14} /> Est. on Toombul Rd
          </p>
          <p className="mt-4 font-display text-4xl font-light leading-tight sm:text-5xl">
            Northgate <span className="italic text-[#FFC61A]">Flavour</span> Express
          </p>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-[#FFF9F1]/70">
            {ADDRESS}
          </p>
          <a href={PHONE_LINK} data-testid="footer-phone-link" className="mt-2 inline-block font-display text-2xl text-[#FFC61A] transition-colors hover:text-[#FFF9F1]">
            {PHONE}
          </a>
        </div>
        <div className="flex flex-wrap gap-4">
          <a
            href={ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-order-btn"
            className="rounded-full bg-[#E32219] px-7 py-3.5 text-sm font-semibold text-[#FFF9F1] transition-colors duration-300 hover:bg-[#B8170F]"
          >
            Order Online
          </a>
          <a
            href={RESERVE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-reserve-btn"
            className="rounded-full border border-[#FFF9F1]/30 px-7 py-3.5 text-sm font-medium transition-colors duration-300 hover:bg-[#FFF9F1] hover:text-[#3A1F14]"
          >
            Reserve a Table
          </a>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-[#FFF9F1]/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#FFF9F1]/50">
          © {new Date().getFullYear()} Northgate Flavour Express
        </p>
        <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#FFF9F1]/50">
          Closed Sundays · Kitchen from 11:30 am
        </p>
      </div>
    </div>
  </footer>
);
